import React, { useMemo } from "react";
import { useDictionary } from "hooks";

import { API_ANIMAL_OVERSIGHT_PROTOCOLS } from "globals/constants";
import Helper from "./helpers";

import IntegrationComponent from "components/flowable/Integration/IntegrationComponent";

const AnimalProtocolSearch = props => {
	const { onChange, onEvent, config } = props;
	const dictionary = useDictionary("animalProtocolSearch");

	const animalProtocolDictionary = useMemo(() => {
		return {
			headline: dictionary?.headline || "Link to Animal Protocols",
			description: dictionary?.description
		}
	}, [ dictionary ]);

	const cardKeys = useMemo(() => {
		return {
			protocolNumber: dictionary?.protocolNumber ?? "Protocol #",
			title:  dictionary?.title ?? "Title",
			approveDate:  dictionary?.approvalDate ?? "Approval Date",
			expirationDate:  dictionary?.expirationDate ?? "Expiration Date",
			primaryInvestigatorName:  dictionary?.principleInvestigator ?? "PI",
			status:  dictionary?.status ?? "Status"
		}
	}, [ dictionary ]);

	return (
		<IntegrationComponent
			helper={Helper}
			url={API_ANIMAL_OVERSIGHT_PROTOCOLS}
			cardKeys={cardKeys}
			dictionary={animalProtocolDictionary}
			config={config}
			onChange={onChange}
			onEvent={onEvent}
		/>
	);
};

export default AnimalProtocolSearch;
